import React, { useState, useEffect, useRef } from "react";
import { MDBDataTable } from "mdbreact";
import toastr from "toastr";
import { Row, Col, Card, CardBody, Button, Label } from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import moment from "moment";
import axios from "axios";
import accessToken from "../../../helpers/jwt-token-access/accessToken";
import "./manageClass.scss";

const AddClass = (props) => {
  const [master, setMaster] = useState({});
  const [details, setDetails] = useState([]);
  const [classIdTobeUpdated, setClassIdTobeUpdated] = useState(null);
  const [classIdTobeDeleted, setClassTobeDeleted] = useState(null);
  const [confirmDeleteAlert, setConfirmDeleteAlert] = useState(null);
  const API_URL = process.env.REACT_APP_APIURL || "http://localhost:3099/";
  const formRef = useRef();

  useEffect(() => {
    handleTableData();
  }, []);

  const toTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };
  const preUpdateClass = (item) => {
    if (item?.name) {
      setMaster({
        classes_name: item.name,
        classes_id: item._id,
      });
      setClassIdTobeUpdated(item?._id);
    }
  };
  const handleTableData = () => {
    axios
      .get(`${API_URL}classes/list`, {
        headers: {
          "x-access-token": accessToken,
        },
      })
      .then((res) => {
        let result = res.data.data;
        result &&
          result.map((item, index) => {
            item.id = index + 1;
            if (item?.classes_updated_date)
              item.date = moment(item?.classes_updated_date).format(
                "DD-MM-YYYY"
              );
            else if (item?.classes_date)
              item.date = moment(item?.classes_date).format("DD-MM-YYYY");
            else item.date = "";

            if (item?.classes_updated_time)
              item.time = moment(item?.classes_updated_time, "hhmmss").format(
                "hh:mm a"
              );
            else if (item?.classes_time)
              item.time = moment(item?.classes_time, "hhmmss").format(
                "hh:mm a"
              );
            else item.time = "";
            if (item?.classes_updatedby) {
              let updatedBy = item.classes_updatedby || {};
              if (updatedBy?.lastName)
                item.staff = updatedBy?.firstName + " " + updatedBy?.lastName;
              else item.staff = updatedBy?.firstName;
            } else {
              let addedBy = item.classes_addedby || {};
              if (addedBy?.lastName)
                item.staff = addedBy?.firstName + " " + addedBy?.lastName;
              else item.staff = addedBy?.firstName;
            }
            item.action = (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <i
                  className="uil-edit-alt"
                  style={{
                    fontSize: "1.2em",
                    cursor: "pointer",
                    marginLeft: "0.5rem",
                    marginRight: "0.5rem",
                  }}
                  onClick={() => {
                    toTop();
                    preUpdateClass(item);
                  }}
                ></i>
                <i
                  className="uil-trash-alt"
                  style={{ fontSize: "1.2em", cursor: "pointer" }}
                  onClick={() => {
                    setClassTobeDeleted(item._id);
                    setConfirmDeleteAlert(true);
                  }}
                ></i>
              </div>
            );
          });
        setDetails(result);
      });
  };
  const data = {
    columns: [
      {
        label: "#",
        field: "id",
        width: 150,
      },
      {
        label: "Date",
        field: "date",
        width: 150,
      },
      {
        label: "Time",
        field: "time",
        width: 150,
      },

      {
        label: "Class",
        field: "name",
        sort: "desc",
        width: 400,
      },
      {
        label: "Staff",
        field: "staff",
        sort: "desc",
        width: 400,
      },
      {
        label: "Action",
        field: "action",
        width: 300,
      },
    ],
    rows: details,
  };
  const handleInputChange = (e) => {
    setMaster({
      ...master,
      [e.target.name]: e.target.value,
    });
  };
  const handleValidSubmit = (e) => {
    e.preventDefault()
    if (classIdTobeUpdated) {
      axios
        .put(`${API_URL}classes/update`, master, {
          headers: {
            "x-access-token": accessToken,
          },
        })
        .then((res) => {
          if (res.data.status === 200) {
            formRef.current.reset();
            toastr.success("Class updated successfully");
            setMaster({});
            handleTableData();
            setClassIdTobeUpdated(null);
          } else {
            toastr.error("Failed to update class");
          }
        })
        .catch((err) => {
          toastr.error(err.response.data.message);
          return;
        });
    } else {
      axios
        .post(`${API_URL}classes/`, master, {
          headers: {
            "x-access-token": accessToken,
          },
        })
        .then((res) => {
          if (res.data.status === 200) {
            formRef.current.reset();
            toastr.success("Class added successfully");
            setMaster({});
            handleTableData();
          } else {
            toastr.error("Failed to add class");
          }
        })
        .catch((err) => {
          toastr.error(err.response.data.message);
          return;
        });
    }
  };

  function reset(e) {
    e.preventDefault()
    formRef.current.reset()
    setMaster({})
    setClassIdTobeUpdated(null)
  }
  return (
    <>
      {confirmDeleteAlert ? (
        <SweetAlert
          title=""
          showCancel
          confirmButtonText="Delete"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            axios
              .delete(`${API_URL}classes` + "/" + classIdTobeDeleted, {
                headers: {
                  "x-access-token": accessToken,
                },
              })
              .then((res) => {
                if (res.data.success === true) {
                  toastr.success("Class deleted successfully");
                  if (master && master.classes_id === classIdTobeDeleted) {
                    formRef.current.reset();
                    setMaster({});
                    setClassIdTobeUpdated(null);
                  }
                  setClassTobeDeleted(null);
                  handleTableData();
                } else {
                  toastr.error(res.data.message, "Failed to delete class");
                  return;
                }
              })
              .catch((err) => {
                toastr.error(err.response.data.message);
                return;
              });
            setConfirmDeleteAlert(false);
          }}
          onCancel={() => setConfirmDeleteAlert(false)}
        >
          Are you sure you want to delete it?
        </SweetAlert>
      ) : null}
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Home" breadcrumbItem="Manage Class" />
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <AvForm
                    ref={formRef}
                    className="needs-validation"
                    onValidSubmit={(e) => {
                      handleValidSubmit(e);
                    }}
                  >
                    <Row>
                      <Col md="3">
                        <div className="mb-3">
                          <Label htmlFor="validationCustom01">Class</Label>
                          <AvField
                            name="classes_name"
                            placeholder="Class name"
                            type="text"
                            errorMessage="Enter Class Name"
                            className="form-control"
                            required
                            id="validationCustom01"
                            value={master?.classes_name || ""}
                            onChange={handleInputChange}
                          />
                        </div>
                      </Col>

                      <Col md="2">
                        <div className="mb-3" style={{ paddingTop: "25px" }}>
                          {classIdTobeUpdated ? (
                            <Button color="primary" type="submit">
                              {"Update"}
                            </Button>
                          ) : (
                            <Button color="primary" type="submit">
                              {"Submit"}
                            </Button>
                          )}
                          <Button className="mx-2" onClick={(e) => { reset(e) }} color="danger" type="button">
                            Reset
                          </Button>
                        </div>

                      </Col>


                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <MDBDataTable
                    id="manageClassTableId"
                    responsive
                    bordered
                    data={data}
                    searching={true}
                    info={true}
                    disableRetreatAfterSorting={true}
                    entries={20}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};
export default AddClass;
